<!-- <ng4-loading-spinner [timeout]="10000"></ng4-loading-spinner> -->

<ng-container *ngIf="!doneLoading; else loaded">

    <body>
        <div class="container white_bg body_min_height">
            <div class="PageTitle">
                <h2 style="text-align: center;"><b>Enterprise Factory Systems</b></h2>
            </div>
            <div id="preloader-wrapper">
                <div id="preloader" class="preloader2"> </div>
            </div>
        </div>
    </body>

</ng-container>
<ng-template #loaded>
    <!-- check session status resets the timer for a session -->
    <div>
        <div class="navbar navbar-inverse" style="background-color: #003657">
            <!-- <img src="/src/assets/Basic_Template/images/menu_bg.jpg"> -->
            <div class="navbar-inner">
                <div>
                    <div class="navbar-header"> <button data-target=".primary_nav" data-toggle="collapse"
                            class="navbar-toggle" type="button"> <span class="icon-bar"></span> <span
                                class="icon-bar"></span> <span class="icon-bar"></span>
                        </button> </div>
                    <div class="navbar-collapse collapse primary_nav">
                        <ul class="nav navbar-nav" id="headerLinks">
                            <li class="dropdown" id="setup" (click)="sidenav.toggle()"> <a data-toggle="dropdown"
                                    class="dropdown-toggle" style="font-size: 16px" *ngIf="!lockDown">Navigation
                                    <span class="caret"></span>
                                </a>
                                <!-- <ul aria-labelledby="dropdownMenu" role="menu" class="dropdown-menu multi-level">
                                        <li> <a routerLink="/searchSpecialInstructions">Search Special
                                                Instructions</a> </li>
                                        <li> <a href="#">Prehold</a> </li>
                                        <li> <a href="#">Production Setup</a> </li>
                                        <li> <a href="#">Plan Template</a> </li>
                                    </ul> -->
                            </li>

                            <!--<li>
                                <img src="../assets/Basic_Template/images/logo.png" alt="Broadridge Logo"
                                    style="position:absolute; top: -58px; left: 350px">
                            </li>-->
                            <li> <a (click)="helpFunction()">{{ currentModule }} Help</a> </li>
                            <!-- <li *ngIf="pmRead === '-PROD METHOD GROUP READ'"> <a
                                    routerLink="/factoryServices">Factory Services GUI</a> </li> -->
                            <!--    <li id="viewSI"> <a routerLink="/viewSpecialInstructions" >View Special
                                        Instructions</a> </li>
                                <li id="addSI"> <a routerLink="/addSpecialInstructions" >Add Special
                                            Instructions</a> </li> -->

                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <mat-sidenav-container class="example-container">
            <mat-sidenav #sidenav [(opened)]="opened" class="mat-elevation-z8">
                <!-- <h1>Sidenav Content</h1> -->
                <br><br>

                <ul aria-labelledby="sideNavMenu" role="menu" class="sidebarLinks"
                    style="list-style-type: none; margin-right: 10px">
                    <li> <a routerLink="/efs" style="font-size:24px" (click)="currentModule = 'General'"
                            (click)="sidenav.toggle()"><b>Home</b></a></li>
                    <br>
                    <li> <a routerLink="setup" style="font-size:24px" (click)="currentModule = 'Setup'"
                            (click)="sidenav.toggle()">Setup</a>
                        <ul>
                            <li *ngIf="permissionHandlingService.siRead"> <a
                                    (click)="navigateTo('special instructions')" routerLink="/searchSpecialInstructions"
                                    (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Special
                                        Instructions</h4>
                                </a></li> <br>
                            <li *ngIf="permissionHandlingService.phRead"> <a (click)="navigateTo('prehold')"
                                    routerLink="/prehold" (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Prehold</h4>
                                </a></li> <br>
                            <li *ngIf="dmRead === 'NOT-ALLOWED'"> <a (click)="navigateTo('delayed mail')"
                                    routerLink="/delayedMail" (click)="sidenav.toggle()" (click)="fromNav()">Delayed
                                    Mail</a>
                            </li>
                            <!-- <br> -->
                            <li *ngIf="permissionHandlingService.psRead || psRead === 'travellerSetup'"> <a
                                    (click)="navigateTo('production setup')" (click)="sidenav.toggle()"
                                    routerLink="/productionSetup" (click)="fromNav()">
                                    <h4>Production
                                        Setup</h4>
                                </a></li> <br>
                            <li *ngIf="permissionHandlingService.ptRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('plan template')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Plan
                                        Template</h4>
                                </a></li> <br>
                            <li *ngIf="permissionHandlingService.pmRead"> <a routerLink="/productionMethod"
                                    (click)="navigateTo('production method group')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Production Method Group</h4>
                                </a></li> <br>
                            <li *ngIf="paRead === 'Inactive'"> <a style="cursor:pointer;"
                                    (click)="navigateTo('package template')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Package
                                        Template</h4>
                                </a></li>
                            <!-- <br> -->
                            <li *ngIf="permissionHandlingService.csRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('corp setup')" (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Corp
                                        Setup</h4>
                                </a></li> <br>
                            <!-- env === 'dev' || 'QA' -->
                            <li *ngIf="permissionHandlingService.rsRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('rule setup')" (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Rule Setup</h4>
                                </a></li> <br>

                            <li *ngIf="permissionHandlingService.psRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('parameterEntry')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Parameter Entry</h4>
                                </a></li> <br>

                            <li *ngIf="permissionHandlingService.pmRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('perfMeasurements')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Perf Measurements</h4>
                                </a></li> <br>

                            <li *ngIf="permissionHandlingService.pmRead"> <a style="cursor:pointer;"
                                    (click)="navigateTo('corpProfileSetup')" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Corp Profile Setup</h4>
                                </a></li> <br>

                        </ul>
                    </li>
                    <li *ngIf="permissionHandlingService.csRead || permissionHandlingService.phRead">
                        <a routerLink="nationalSetup" style="font-size:24px" (click)="currentModule = 'nationalSetup'"
                            (click)="sidenav.toggle()">National Setup</a>
                        <ul>
                            <li> <a (click)="navigateTo('national dispatch template')"
                                    routerLink="nationalSetup/nationalDispatchTemplate" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>National Dispatch Template</h4>
                                </a></li> <br>
                            <li> <a (click)="navigateTo('national corp setup')"
                                    routerLink="nationalSetup/nationalCorpSetup" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>National Corp Setup</h4>
                                </a></li> <br>
                        </ul>
                    </li>
                    <li> <a routerLink="clientSummary" style="font-size:24px" (click)="currentModule = 'clientSummary'"
                            (click)="sidenav.toggle()">National Dashboard</a>
                        <ul>
                            <li> <a (click)="navigateTo('client summary')" routerLink="clientSummary"
                                    (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Client Summary</h4>
                                </a></li> <br>
                        </ul>
                    </li>
                    <li *ngIf="permissionHandlingService.raWrite"> <a routerLink="roleAdmin" style="font-size:24px"
                            (click)="currentModule = 'roleAdmin'" (click)="sidenav.toggle()">Role Admin</a>
                        <ul>

                            <!-- <li> <a (click)="navigateTo('role admin')" routerLink="roleAdmin" (click)="sidenav.toggle()"
                                    (click)="fromNav()">
                                    <h4>Role Administration</h4>
                                </a></li> <br> -->
                        </ul>
                    </li>
                    <li *ngIf="permissionHandlingService.raWrite"> <a routerLink="singleUserSetupICC"
                            style="font-size:24px" (click)="navigateTo('singleUserSetupICC')"
                            (click)="sidenav.toggle()">
                            <h3>Single User Setup ICC</h3>
                        </a>
                        <ul>

                            <!-- <li> <a (click)="navigateTo('role admin')" routerLink="roleAdmin" (click)="sidenav.toggle()"
                                (click)="fromNav()">
                                <h4>Role Administration</h4>
                            </a></li> <br> -->
                        </ul>
                    </li>
                    <li *ngIf="permissionHandlingService.midWrite"> <a routerLink="mailerIdSetup" style="font-size:24px"
                            (click)="navigateTo('mailerIdSetup')" (click)="sidenav.toggle()">
                            <h3>Mailer ID Setup</h3>
                        </a>
                        <ul>

                        </ul>
                    </li>
                    <li *ngIf="permissionHandlingService.slaWrite"> <a (click)="navigateTo('corpSlaExportReport')"
                            routerLink="corpSlaExportReport" (click)="sidenav.toggle()" (click)="fromNav()">
                            <h3>Corp SLA Export Report</h3>
                        </a></li> <br>

                    <li *ngIf="this.permissionHandlingService.permissionsMap.get('EFS- A&R READ')"> <a
                            (click)="navigateTo('archivalAndRetrieval')" routerLink="archivalAndRetrieval"
                            (click)="sidenav.toggle()" (click)="fromNav()">
                            <h3>Archival and Retrieval</h3>
                        </a></li> <br>

                    <li *ngIf="this.permissionHandlingService.permissionsMap.get('EFS- A&R READ')"> <a
                            (click)="navigateTo('MKBillOfMaterial')" routerLink="MKBillOfMaterial"
                            (click)="sidenav.toggle()" (click)="fromNav()">
                            <h3>MK Bill Of Material</h3>
                        </a></li> <br>

                    <!-- <li *ngIf="this.permissionHandlingService.permissionsMap.get('EFS- A&R READ')"> <a
                            (click)="navigateTo('agreementsScreen')" routerLink="agreementsScreen"
                            (click)="sidenav.toggle()" (click)="fromNav()">
                            <h3>Agreements</h3>
                        </a></li> <br> -->

                    <!-- disabled for now -->
                    <!-- <li> <a routerLink="roleAdmin" style="font-size:24px" (click)="sidenav.toggle()">Corp SLA Export
                            Report</a>
                        <ul>
                            <li *ngIf="permissionHandlingService.slaWrite"> <a
                                    (click)="navigateTo('corpSlaExportReport')" routerLink="corpSlaExportReport"
                                    (click)="sidenav.toggle()" (click)="fromNav()">
                                    <h4>Client SLA Report</h4>
                                </a></li> <br>
                        </ul>
                    </li> -->
                </ul>
            </mat-sidenav>
            <mat-sidenav-content>

                <app-breadcrumb></app-breadcrumb>

                <router-outlet></router-outlet>
                <br><br>

            </mat-sidenav-content>
        </mat-sidenav-container>

    </div>
</ng-template>

<!-- footer -->
<!-- <div id="footer" style="background-color: #003657">
    <div class="row">
        <div class="col-md-12" style="text-align:center;position: absolute;
    width: 100%;">
            <h4>
                ©{{currentYear}} Broadridge Financial Solutions, Inc. All rights reserved. <br>
                Version {{version}} <br>
            </h4>
            <span class="notice">
                <h4>NOTICE: Broadridge is not affiliated with DST Systems.</h4>
            </span>
        </div>
    </div>
</div> -->

<footer id="footer">
    <div class="container">
        <div class="footerLinks">
            <h2 class="footer_title">Enterprise Factory Systems Version {{version}}</h2>
            <ul class="mb-0 d-md-block d-none">
                <li><a href="http://broadridge.com/privacy.asp" target="_blank">Privacy Statement</a></li>
                <li><a href="http://broadridge.com/terms.asp" target="_blank">Terms and Conditions</a></li>
            </ul>
        </div>
        <div class="copyRight"> © {{currentYear}} Broadridge Financial Solutions, Inc. The Broadridge Logo is a
            registered trademark of Broadridge North America, Inc. </div>
    </div>
</footer>

<!-- <pdf-viewer src="../assets/Basic_Template/pdf/EFS_Special_Ins_userguide.pdf" [render-text]="true" style="display: block;"></pdf-viewer> -->